import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0a9a73",
    },
    secondary: {
      main: "#20bfa9",
    },
  },
  typography: {
    fontFamily: ["Josefin Sans", "sans-serif"].join(","),
    // fontFamily: ["Poppins", "sans-serif"].join(","),
    fontSize: 14,
    h4: {
      fontSize: "26px",
      fontWeight: "700",
      // "@media (max-width:767px)": {
      //   fontSize: "18px",
      // },
    },
    h5: {
      fontSize: "21px",
      fontWeight: "700",
      // "@media (max-width:767px)": {
      //   fontSize: "18px",
      // },
    },
    h6: {
      fontSize: "18px",
      fontWeight: "600 !important",
      "@media (max-width:767px)": {
        fontSize: "16px",
      },
    },
    subtitle1: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "normal",
    },
    body1: {
      fontSize: "16px",
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: "14px",
      fontWeight: 600,
      textTransform: "capitalize",
    },
    body2: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "21px",
    },
    caption: {
      fontSize: "12px",
      fontWeight: 400,
    },
    overline: {
      fontSize: "12px",
    },
    button: {
      textTransform: 'initial'
    }
  },
});

export default function CustomThemeProvider({ children }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
